// Quick Wins Database - Actionable recommendations for Partial/No answers
// Each question has 2-3 quick wins with timeline, effort, and resources

export const quickWinsDatabase = {
  // Clause 4: Context of the Organization
  'clause4-0': [
    {
      id: 'qw-4-0-1',
      title: 'Conduct PESTLE Analysis Workshop',
      action: 'Organize a 2-hour workshop with key stakeholders to identify external and internal factors affecting AI initiatives',
      timeline: 'immediate',
      timelineText: '1-3 days',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'high',
      resources: ['PESTLE Analysis Template', 'Workshop Agenda'],
      clauseId: 'clause4',
      questionIndex: 0
    },
    {
      id: 'qw-4-0-2',
      title: 'Create Issues Register',
      action: 'Download and populate an issues register documenting all relevant internal/external factors',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'medium',
      resources: ['Issues Register Template'],
      clauseId: 'clause4',
      questionIndex: 0
    }
  ],
  'clause4-1': [
    {
      id: 'qw-4-1-1',
      title: 'Legal Compliance Checklist',
      action: 'Create a checklist of applicable AI regulations (GDPR, AI Act, etc.) for your industry',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'critical',
      resources: ['Legal Requirements Template', 'Compliance Checklist'],
      clauseId: 'clause4',
      questionIndex: 1
    },
    {
      id: 'qw-4-1-2',
      title: 'Set Up Compliance Tracker',
      action: 'Implement a simple spreadsheet to track regulatory updates and obligations',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'high',
      resources: ['Compliance Tracker Template'],
      clauseId: 'clause4',
      questionIndex: 1
    }
  ],
  'clause4-2': [
    {
      id: 'qw-4-2-1',
      title: 'AI Strategy Alignment Meeting',
      action: 'Schedule executive meeting to align AI initiatives with organizational strategic goals',
      timeline: 'immediate',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '2 hours',
      impact: 'high',
      resources: ['Meeting Agenda Template', 'Strategy Alignment Framework'],
      clauseId: 'clause4',
      questionIndex: 2
    }
  ],
  'clause4-3': [
    {
      id: 'qw-4-3-1',
      title: 'Stakeholder Mapping Exercise',
      action: 'Create a comprehensive stakeholder map identifying all interested parties',
      timeline: 'immediate',
      timelineText: '2-3 days',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'high',
      resources: ['Stakeholder Map Template', 'Analysis Matrix'],
      clauseId: 'clause4',
      questionIndex: 3
    },
    {
      id: 'qw-4-3-2',
      title: 'Conduct Stakeholder Interviews',
      action: 'Schedule 30-minute interviews with key stakeholders to understand their expectations',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'medium',
      effortHours: '10 hours',
      impact: 'high',
      resources: ['Interview Question Template'],
      clauseId: 'clause4',
      questionIndex: 3
    }
  ],
  'clause4-4': [
    {
      id: 'qw-4-4-1',
      title: 'Document Stakeholder Requirements',
      action: 'Create a requirements register documenting expectations from all interested parties',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['Requirements Register Template'],
      clauseId: 'clause4',
      questionIndex: 4
    }
  ],
  'clause4-5': [
    {
      id: 'qw-4-5-1',
      title: 'Implement Review Schedule',
      action: 'Set up quarterly stakeholder requirement reviews in your calendar',
      timeline: 'immediate',
      timelineText: '1 day',
      effort: 'low',
      effortHours: '1 hour',
      impact: 'medium',
      resources: ['Review Schedule Template'],
      clauseId: 'clause4',
      questionIndex: 5
    }
  ],
  'clause4-6': [
    {
      id: 'qw-4-6-1',
      title: 'Draft AIMS Scope Statement',
      action: 'Write a clear 1-2 page scope document defining AIMS boundaries',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'critical',
      resources: ['Scope Statement Template', 'Example Scope Docs'],
      clauseId: 'clause4',
      questionIndex: 6
    }
  ],
  'clause4-7': [
    {
      id: 'qw-4-7-1',
      title: 'Create System Dependency Map',
      action: 'Document interfaces and dependencies with other organizational systems',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '10 hours',
      impact: 'high',
      resources: ['System Dependency Template'],
      clauseId: 'clause4',
      questionIndex: 7
    }
  ],
  'clause4-8': [
    {
      id: 'qw-4-8-1',
      title: 'Process Mapping Workshop',
      action: 'Conduct process mapping session to identify all AIMS-related processes',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'high',
      effortHours: '20 hours',
      impact: 'critical',
      resources: ['Process Mapping Template', 'Flowchart Tools'],
      clauseId: 'clause4',
      questionIndex: 8
    }
  ],
  'clause4-9': [
    {
      id: 'qw-4-9-1',
      title: 'Set Up Improvement Register',
      action: 'Create a system to track and implement continuous improvements',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'medium',
      resources: ['Improvement Register Template'],
      clauseId: 'clause4',
      questionIndex: 9
    }
  ],

  // Clause 5: Leadership
  'clause5-0': [
    {
      id: 'qw-5-0-1',
      title: 'Leadership Commitment Meeting',
      action: 'Schedule 1-hour AIMS briefing with CEO/top management to secure visible commitment',
      timeline: 'immediate',
      timelineText: 'Tomorrow',
      effort: 'low',
      effortHours: '2 hours prep',
      impact: 'critical',
      resources: ['Executive Briefing Template', 'Presentation Deck'],
      clauseId: 'clause5',
      questionIndex: 0
    },
    {
      id: 'qw-5-0-2',
      title: 'Create Leadership Dashboard',
      action: 'Build executive dashboard showing key AI KPIs and AIMS performance',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['Dashboard Template', 'KPI List'],
      clauseId: 'clause5',
      questionIndex: 0
    }
  ],
  'clause5-1': [
    {
      id: 'qw-5-1-1',
      title: 'Budget Allocation Request',
      action: 'Prepare and submit budget proposal for AIMS resources to top management',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'critical',
      resources: ['Budget Template', 'ROI Calculator'],
      clauseId: 'clause5',
      questionIndex: 1
    }
  ],
  'clause5-2': [
    {
      id: 'qw-5-2-1',
      title: 'Process Integration Assessment',
      action: 'Review existing business processes and identify integration points for AIMS',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'medium',
      effortHours: '12 hours',
      impact: 'high',
      resources: ['Integration Checklist'],
      clauseId: 'clause5',
      questionIndex: 2
    }
  ],
  'clause5-3': [
    {
      id: 'qw-5-3-1',
      title: 'Draft AI Policy Document',
      action: 'Download and customize AI Policy template for your organization',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'critical',
      resources: ['AI Policy Template', 'Policy Examples'],
      clauseId: 'clause5',
      questionIndex: 3
    },
    {
      id: 'qw-5-3-2',
      title: 'Policy Review Meeting',
      action: 'Schedule review session with stakeholders to finalize AI Policy',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '2 hours',
      impact: 'high',
      resources: ['Review Checklist'],
      clauseId: 'clause5',
      questionIndex: 3
    }
  ],
  'clause5-4': [
    {
      id: 'qw-5-4-1',
      title: 'Add Compliance Statement',
      action: 'Update AI Policy to include explicit commitment to legal/regulatory compliance',
      timeline: 'immediate',
      timelineText: '1 day',
      effort: 'low',
      effortHours: '2 hours',
      impact: 'critical',
      resources: ['Compliance Statement Template'],
      clauseId: 'clause5',
      questionIndex: 4
    }
  ],
  'clause5-5': [
    {
      id: 'qw-5-5-1',
      title: 'Policy Communication Plan',
      action: 'Create and execute internal communication plan to share AI Policy',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'medium',
      resources: ['Communication Plan Template', 'Email Templates'],
      clauseId: 'clause5',
      questionIndex: 5
    }
  ],
  'clause5-6': [
    {
      id: 'qw-5-6-1',
      title: 'Create RACI Matrix',
      action: 'Develop RACI matrix documenting roles and responsibilities for AIMS',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'high',
      resources: ['RACI Matrix Template'],
      clauseId: 'clause5',
      questionIndex: 6
    }
  ],
  'clause5-7': [
    {
      id: 'qw-5-7-1',
      title: 'Designate AIMS Manager',
      action: 'Assign specific individual/role responsibility for AIMS performance reporting',
      timeline: 'immediate',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '2 hours',
      impact: 'high',
      resources: ['Job Description Template'],
      clauseId: 'clause5',
      questionIndex: 7
    }
  ],
  'clause5-8': [
    {
      id: 'qw-5-8-1',
      title: 'Define Decision Authority',
      action: 'Document decision-making authority matrix for AI system lifecycle',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'critical',
      resources: ['Authority Matrix Template'],
      clauseId: 'clause5',
      questionIndex: 8
    }
  ],
  'clause5-9': [
    {
      id: 'qw-5-9-1',
      title: 'Role Communication Campaign',
      action: 'Send organization-wide communication detailing AIMS roles and responsibilities',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'medium',
      resources: ['Communication Template'],
      clauseId: 'clause5',
      questionIndex: 9
    }
  ],

  // Clause 6: Planning
  'clause6-0': [
    {
      id: 'qw-6-0-1',
      title: 'Risk & Opportunity Register',
      action: 'Create initial register documenting AI risks and opportunities',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['Risk Register Template', 'Examples'],
      clauseId: 'clause6',
      questionIndex: 0
    }
  ],
  'clause6-1': [
    {
      id: 'qw-6-1-1',
      title: 'Risk Assessment Workshop',
      action: 'Conduct 2-hour risk assessment workshop with cross-functional team',
      timeline: 'immediate',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'critical',
      resources: ['Workshop Guide', 'Risk Assessment Template'],
      clauseId: 'clause6',
      questionIndex: 1
    },
    {
      id: 'qw-6-1-2',
      title: 'Document Risk Process',
      action: 'Write formal risk assessment process document following ISO 42001',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '10 hours',
      impact: 'critical',
      resources: ['Process Document Template'],
      clauseId: 'clause6',
      questionIndex: 1
    }
  ],
  'clause6-2': [
    {
      id: 'qw-6-2-1',
      title: 'Define Risk Criteria',
      action: 'Establish and document clear risk evaluation criteria and acceptable risk levels',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'high',
      resources: ['Risk Criteria Template', 'Examples'],
      clauseId: 'clause6',
      questionIndex: 2
    }
  ],
  'clause6-3': [
    {
      id: 'qw-6-3-1',
      title: 'Lifecycle Risk Schedule',
      action: 'Create risk assessment schedule for all AI system lifecycle stages',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'medium',
      resources: ['Schedule Template'],
      clauseId: 'clause6',
      questionIndex: 3
    }
  ],
  'clause6-4': [
    {
      id: 'qw-6-4-1',
      title: 'Assign Risk Owners',
      action: 'Identify and assign ownership for each documented AI risk',
      timeline: 'immediate',
      timelineText: '1 day',
      effort: 'low',
      effortHours: '2 hours',
      impact: 'high',
      resources: ['Risk Owner Template'],
      clauseId: 'clause6',
      questionIndex: 4
    }
  ],
  'clause6-5': [
    {
      id: 'qw-6-5-1',
      title: 'Create Risk Treatment Plan',
      action: 'Develop comprehensive plan detailing how each risk will be treated',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'high',
      effortHours: '16 hours',
      impact: 'critical',
      resources: ['Treatment Plan Template'],
      clauseId: 'clause6',
      questionIndex: 5
    }
  ],
  'clause6-6': [
    {
      id: 'qw-6-6-1',
      title: 'Draft Statement of Applicability',
      action: 'Create SoA documenting which ISO 42001 controls are applicable',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'high',
      effortHours: '20 hours',
      impact: 'critical',
      resources: ['SoA Template', 'Control List'],
      clauseId: 'clause6',
      questionIndex: 6
    }
  ],
  'clause6-7': [
    {
      id: 'qw-6-7-1',
      title: 'Residual Risk Review',
      action: 'Schedule formal review meeting for residual risk acceptance',
      timeline: 'immediate',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'high',
      resources: ['Review Checklist'],
      clauseId: 'clause6',
      questionIndex: 7
    }
  ],
  'clause6-8': [
    {
      id: 'qw-6-8-1',
      title: 'Define AI Objectives',
      action: 'Set measurable AI objectives aligned with organizational strategy',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['Objectives Template', 'SMART Goals Guide'],
      clauseId: 'clause6',
      questionIndex: 8
    }
  ],
  'clause6-9': [
    {
      id: 'qw-6-9-1',
      title: 'Objectives Monitoring System',
      action: 'Implement dashboard or tracking system for AI objectives monitoring',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'medium',
      effortHours: '10 hours',
      impact: 'medium',
      resources: ['Monitoring Template'],
      clauseId: 'clause6',
      questionIndex: 9
    }
  ],

  // Clause 7: Support (shortened for brevity - continuing pattern)
  'clause7-0': [
    {
      id: 'qw-7-0-1',
      title: 'Resource Gap Analysis',
      action: 'Conduct analysis to identify resource gaps for AIMS implementation',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['Gap Analysis Template'],
      clauseId: 'clause7',
      questionIndex: 0
    }
  ],
  'clause7-1': [
    {
      id: 'qw-7-1-1',
      title: 'Data Quality Assessment',
      action: 'Evaluate current data quality and create improvement plan',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'high',
      effortHours: '16 hours',
      impact: 'critical',
      resources: ['Data Quality Framework'],
      clauseId: 'clause7',
      questionIndex: 1
    }
  ],
  'clause7-2': [
    {
      id: 'qw-7-2-1',
      title: 'Competency Matrix',
      action: 'Create competency matrix for all AI-related roles',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'high',
      resources: ['Competency Matrix Template'],
      clauseId: 'clause7',
      questionIndex: 2
    }
  ],
  'clause7-3': [
    {
      id: 'qw-7-3-1',
      title: 'Training Program',
      action: 'Develop and schedule AIMS awareness training for all staff',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'high',
      effortHours: '20 hours',
      impact: 'high',
      resources: ['Training Plan Template', 'Slides'],
      clauseId: 'clause7',
      questionIndex: 3
    }
  ],
  'clause7-4': [
    {
      id: 'qw-7-4-1',
      title: 'Awareness Campaign',
      action: 'Launch internal campaign communicating AI Policy and objectives',
      timeline: 'immediate',
      timelineText: '1 week',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'medium',
      resources: ['Campaign Materials'],
      clauseId: 'clause7',
      questionIndex: 4
    }
  ],
  'clause7-5': [
    {
      id: 'qw-7-5-1',
      title: 'Consequences Communication',
      action: 'Document and communicate consequences of non-conformance',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'medium',
      resources: ['Communication Template'],
      clauseId: 'clause7',
      questionIndex: 5
    }
  ],
  'clause7-6': [
    {
      id: 'qw-7-6-1',
      title: 'Communication Protocol',
      action: 'Establish formal communication protocols for AIMS',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'high',
      resources: ['Protocol Template'],
      clauseId: 'clause7',
      questionIndex: 6
    }
  ],
  'clause7-7': [
    {
      id: 'qw-7-7-1',
      title: 'Incident Response Plan',
      action: 'Create AI incident response and communication plan',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'high',
      effortHours: '12 hours',
      impact: 'critical',
      resources: ['Response Plan Template'],
      clauseId: 'clause7',
      questionIndex: 7
    }
  ],
  'clause7-8': [
    {
      id: 'qw-7-8-1',
      title: 'Document Control System',
      action: 'Implement document management system for AIMS documentation',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'medium',
      effortHours: '10 hours',
      impact: 'high',
      resources: ['Document Control Procedure'],
      clauseId: 'clause7',
      questionIndex: 8
    }
  ],
  'clause7-9': [
    {
      id: 'qw-7-9-1',
      title: 'External Document Register',
      action: 'Create register of external documents required for AIMS',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'low',
      effortHours: '3 hours',
      impact: 'medium',
      resources: ['Document Register Template'],
      clauseId: 'clause7',
      questionIndex: 9
    }
  ],

  // Continuing with remaining clauses... (Clause 8, 9, 10)
  // Due to length, I'll add representative samples

  // Clause 8: Operation
  'clause8-0': [
    {
      id: 'qw-8-0-1',
      title: 'Operational Process Documentation',
      action: 'Document all operational processes for AI system management',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'high',
      effortHours: '20 hours',
      impact: 'critical',
      resources: ['Process Documentation Template'],
      clauseId: 'clause8',
      questionIndex: 0
    }
  ],
  'clause8-1': [
    {
      id: 'qw-8-1-1',
      title: 'Define Acceptance Criteria',
      action: 'Establish clear criteria for AI system acceptance',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'high',
      resources: ['Criteria Template'],
      clauseId: 'clause8',
      questionIndex: 1
    }
  ],
  'clause8-2': [
    {
      id: 'qw-8-2-1',
      title: 'Risk Assessment Schedule',
      action: 'Create and implement recurring risk assessment schedule',
      timeline: 'immediate',
      timelineText: '1 day',
      effort: 'low',
      effortHours: '2 hours',
      impact: 'high',
      resources: ['Assessment Schedule Template'],
      clauseId: 'clause8',
      questionIndex: 2
    }
  ],

  // Clause 9: Performance Evaluation
  'clause9-0': [
    {
      id: 'qw-9-0-1',
      title: 'Define KPIs',
      action: 'Establish key performance indicators for AIMS and AI systems',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['KPI Framework', 'Examples'],
      clauseId: 'clause9',
      questionIndex: 0
    }
  ],
  'clause9-1': [
    {
      id: 'qw-9-1-1',
      title: 'Monitoring Methods',
      action: 'Define and document monitoring and measurement methods',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '10 hours',
      impact: 'high',
      resources: ['Monitoring Procedure Template'],
      clauseId: 'clause9',
      questionIndex: 1
    }
  ],
  'clause9-4': [
    {
      id: 'qw-9-4-1',
      title: 'Internal Audit Plan',
      action: 'Create annual internal audit schedule for AIMS',
      timeline: 'immediate',
      timelineText: '2 days',
      effort: 'low',
      effortHours: '4 hours',
      impact: 'critical',
      resources: ['Audit Plan Template', 'Checklist'],
      clauseId: 'clause9',
      questionIndex: 4
    }
  ],

  // Clause 10: Improvement
  'clause10-0': [
    {
      id: 'qw-10-0-1',
      title: 'Nonconformity Procedure',
      action: 'Document formal procedure for handling nonconformities',
      timeline: 'immediate',
      timelineText: '3 days',
      effort: 'medium',
      effortHours: '6 hours',
      impact: 'high',
      resources: ['Nonconformity Procedure Template'],
      clauseId: 'clause10',
      questionIndex: 0
    }
  ],
  'clause10-1': [
    {
      id: 'qw-10-1-1',
      title: 'Root Cause Analysis Training',
      action: 'Train team on root cause analysis methodologies (5 Whys, Fishbone)',
      timeline: 'short',
      timelineText: '1 week',
      effort: 'medium',
      effortHours: '8 hours',
      impact: 'high',
      resources: ['RCA Training Materials'],
      clauseId: 'clause10',
      questionIndex: 1
    }
  ],
  'clause10-5': [
    {
      id: 'qw-10-5-1',
      title: 'Improvement Framework',
      action: 'Implement continuous improvement framework (PDCA, Kaizen)',
      timeline: 'short',
      timelineText: '2 weeks',
      effort: 'high',
      effortHours: '16 hours',
      impact: 'high',
      resources: ['Improvement Framework Guide'],
      clauseId: 'clause10',
      questionIndex: 5
    }
  ]
};

// Helper functions
export const getQuickWinsForQuestion = (clauseId, questionIndex, response) => {
  if (response === 'yes') return [];
  
  const key = `${clauseId}-${questionIndex}`;
  return quickWinsDatabase[key] || [];
};

export const getAllQuickWins = (auditResponses) => {
  const quickWins = [];
  
  Object.entries(auditResponses).forEach(([key, response]) => {
    if (response !== 'yes') {
      const wins = quickWinsDatabase[key] || [];
      quickWins.push(...wins);
    }
  });
  
  return quickWins;
};

export const getQuickWinsByPriority = (quickWins) => {
  const critical = quickWins.filter(qw => qw.impact === 'critical');
  const high = quickWins.filter(qw => qw.impact === 'high');
  const medium = quickWins.filter(qw => qw.impact === 'medium');
  
  return { critical, high, medium };
};

export const getQuickWinsByTimeline = (quickWins) => {
  const immediate = quickWins.filter(qw => qw.timeline === 'immediate');
  const short = quickWins.filter(qw => qw.timeline === 'short');
  const medium = quickWins.filter(qw => qw.timeline === 'medium');
  
  return { immediate, short, medium };
};

export const getQuickWinsByEffort = (quickWins) => {
  const low = quickWins.filter(qw => qw.effort === 'low');
  const med = quickWins.filter(qw => qw.effort === 'medium');
  const high = quickWins.filter(qw => qw.effort === 'high');
  
  return { low, medium: med, high };
};
